import {
    useLoaderData,
    } from "react-router-dom";
    
    export async function loader({ params }) {
      return null;
    }
    
    export async function action({ params }) {
      return null; 
    }
    
    export default function TestAction() {
      const loaderData = useLoaderData();
    
      return (
        <div>
          <div className="helpHeader"> Help</div>
          <div className="helpBody"> Help page in progress.</div>
        </div>
      );
    }